export default {
  navHome: "Strona główna",
  navProducts: "Produkty",
  navCases: "Przypadki zastosowań",
  navAbout: "O nas",
  deliverTo: "Dostawa do:",
  langCurrencyLabel: "Polski",
  localeLangTitle: "Ustaw język",
  localeLangDesc:
    "Wybierz preferowany język. Możesz zaktualizować to ustawienie w dowolnym momencie.",
  language: "Język",
  save: "Zapisz",
  coreProducts: "Wspieramy tworzenie w realnym świecie.",
  coreProductsDesc:
    "Od pomysłu do biznesu �?YONGYUAN oferuje drukarki UV, drukarki etykiet kryształowych, wysokoprędkościowe drukarki cylindryczne, drukarki DTF i DTG, przekształcając kreatywność w produkty, marki i możliwości.",
  scenariosTitle: "Rozwiązania dla każdego scenariusza",
  scenariosDesc:
    "Niezależnie od tego, czy budujesz markę, rozwijasz dodatkową działalność, czy realizujesz pasje twórcze, YONGYUAN oferuje rozwiązanie dopasowane do Twoich potrzeb.",
  scenarioStudio: "Studio",
  scenarioStudioDesc:
    "Personalizacja wysokiej wartości, prototypowanie małych serii i budowanie marki",
  scenarioRetail: "Retail markowy",
  scenarioRetailDesc:
    "Wydłuż czas pobytu klientów i zwiększ przychody sklepu",
  scenarioMarket: "Targ uliczny",
  scenarioMarketDesc:
    "Personalizacja na miejscu, sprzedaż gotowych produktów i dodatkowy dochód",
  scenarioEnterprise: "Personalizacja firmowa",
  scenarioEnterpriseDesc:
    "Personalizacja seryjna, gadżety markowe i prezenty korporacyjne",
  scenarioEcommerce: "Sprzedaż na żywo",
  scenarioEcommerceDesc:
    "Próbki hitowych produktów, elastyczne dostawy i szybkie wprowadzanie produktów",
  scenarioStore: "Sklep e-commerce",
  scenarioStoreDesc:
    "Personalizacja sklepu, hitowe gadżety i zróżnicowane operacje",
  scenarioFactory: "Produkcja fabryczna",
  scenarioFactoryDesc:
    "Produkcja seryjna, stabilny wynik i opłacalne operacje",
  scenarioAdvertising: "Produkcja reklamowa",
  scenarioAdvertisingDesc:
    "Szyldy, materiały wystawowe i materiały eventowe",
  industries: "Zastosowania branżowe",
  industriesDesc:
    "Rozwiązania cyfrowego druku atramentowego do druku kolorowego w różnych branżach.",
  applicationsTitle:
    "Odblokuj wszechstronne zastosowania materiałów i kolorów na potrzeby codzienne i komercyjne.",
  applicationsDesc:
    "Sprzęt do druku UV YONGYUAN jest zaprojektowany dla szerokiej gamy materiałów i scenariuszy procesowych, wspierając personalizację i produkcję na dużą skalę.",
  casesHeroDesc:
    "Ponad 1200 zastosowań branżowych i dziesiątki tysięcy materiałów do druku — cyfrowe rozwiązania drukarskie dla różnych biznesów.",
  casesBreadcrumbHome: "Strona główna",
  casesBreadcrumbCenter: "Przypadki zastosowań",
  casesEmpty: "Brak przypadków zastosowań w tej kategorii.",
  customerStoriesTitle: "Zaufany przez klientów na całym świecie",
  customerStoriesSubtitle:
    "Prawdziwe instalacje, prawdziwi klienci, prawdziwe firmy poligraficzne w 172 krajach.",
  customerStoriesStat1Value: "53 000+",
  customerStoriesStat1Label: "Dostarczone drukarki",
  customerStoriesStat2Value: "172+",
  customerStoriesStat2Label: "Obsługiwane kraje",
  customerStoriesStat3Value: "23+",
  customerStoriesStat3Label: "Lat doświadczenia",
  customerStoriesStat4Value: "24/7",
  customerStoriesStat4Label: "Wsparcie techniczne",
  customerStoriesPlaceholder: "Dodaj zdjęcie klienta",
  customerStoriesPhotoAlt: "Klient YONGYUAN z drukarką",
  servicePartnerTitle:
    "Poznaj zespół serwisowy YONGYUAN, Twojego partnera kreatywnego",
  servicePartnerDesc:
    "Globalna sieć serwisowa i profesjonalny system wsparcia chroniący wydajność sprzętu i rozwój biznesu.",
  serviceSupportTitle: "Standardowe wsparcie",
  serviceSupportDesc:
    "Instrukcja instalacji, podstawowe szkolenie i codzienna pomoc w użytkowaniu dla niezawodnej pracy sprzętu.",
  servicePresaleTitle: "Demo i konsultacja przed sprzedażą",
  servicePresaleDesc:
    "Demonstracje rozwiązań i rekomendacje modeli dopasowane do scenariuszy zastosowania i wymagań wydajnościowych.",
  serviceLifetimeTitle: "Dożywotnie wsparcie techniczne",
  serviceLifetimeDesc:
    "Ciągła odpowiedź techniczna i wsparcie procesów towarzyszące długoterminowemu rozwojowi biznesu.",
  serviceCareTitle: "Przejdź na YONGYUAN Care",
  serviceCareDamageTitle: "Ochrona przed przypadkowymi uszkodzeniami",
  serviceCareDamageDesc:
    "Bardziej kompleksowy plan ochrony redukujący straty spowodowane nieoczekiwanymi zdarzeniami.",
  serviceCareExchangeTitle: "Szybka wymiana",
  serviceCareExchangeDesc:
    "Priorytetowe szybkie wymiany w kwalifikujących się warunkach przyspieszające odzyskanie kapitału.",
  viewProduct: "Zobacz produkty",
  learnMore: "Dowiedz się więcej",
  catUv: "Drukarka UV płaska",
  catCylinder: "Drukarka cylindryczna",
  catCrystal: "Drukarka etykiet kryształowych",
  catDtf: "Drukarka DTF",
  catDtg: "Drukarka DTG",
  companyName: "Shenzhen Yongyuan Technology Co., Ltd.",
  phone: "Telefon: 17748697567 Manager Tang",
  email: "E-mail: sales@yongyuanprinter.com",
  copyright:
    "Copyright © 2012-2026 Shenzhen Yongyuan Technology Co., Ltd. Wszelkie prawa zastrzeżone",
  productsHeroTitle: "Produkty",
  productsHeroDesc:
    "Pełna linia sprzętu UV płaskiego, cylindrycznego, etykiet kryształowych, DTF i DTG dla różnych potrzeb wydajnościowych i zastosowań.",
  productsBreadcrumbHome: "Strona główna",
  productsBreadcrumbCenter: "Produkty",
  productsEmpty: "Produkty w tej kategorii wkrótce.",
  productsQuoteTitle: "Zapytaj o rozwiązanie i wycenę",
  productsQuoteDesc:
    "Podziel się scenariuszami zastosowania i wymaganiami wydajnościowymi �?zarekomendujemy odpowiednie rozwiązanie sprzętowe.",
  productsContact: "Skontaktuj się",
  aboutHeroTitle: "O Yongyuan",
  aboutHeroDesc:
    "23 lat skupienia na badaniach, rozwoju i produkcji sprzętu do druku UV",
  productA23Subtitle: "Biurkowa inteligentna drukarka UV 6-kolorowa",
  productA23Feature1: "Format druku A4",
  productA23Feature2: "Inteligentny system zasilania atramentem",
  productA23Feature3: "Automatyczne wykrywanie wysokości na podczerwień",
  productA35Subtitle: "Biurkowa inteligentna drukarka UV 6-kolorowa",
  productA35Feature1: "Format druku A3+",
  productA35Feature2: "Inteligentny system zasilania atramentem",
  productA35Feature3: "Automatyczne wykrywanie wysokości na podczerwień",
  productA43Subtitle: "Flagowa inteligentna drukarka UV 8-kolorowa",
  productA43Feature1: "Format druku A3",
  productA43Feature2: "Wiele konfiguracji głowic drukujących",
  productA43Feature3: "Inteligentny system zasilania atramentem",
  productA46Subtitle: "Flagowa inteligentna drukarka UV 8-kolorowa",
  productA46Feature1: "Format druku A2",
  productA46Feature2: "Wiele konfiguracji głowic drukujących",
  productA46Feature3: "Inteligentny system zasilania atramentem",
  productA57Subtitle: "Flagowa inteligentna drukarka UV 8-kolorowa",
  productA57Feature1: "Format druku A2+",
  productA57Feature2: "Wiele konfiguracji głowic drukujących",
  productA57Feature3: "Inteligentny system zasilania atramentem",
  productA69Subtitle: "Flagowa inteligentna drukarka UV 8-kolorowa",
  productA69Feature1: "Format druku A1",
  productA69Feature2: "Wiele konfiguracji głowic drukujących",
  productA69Feature3: "Inteligentny system zasilania atramentem",
  productA1216Subtitle: "Flagowa wielkoformatowa drukarka UV płaska",
  productA1216Feature1: "Format druku 1200×1600cm",
  productA1216Feature2: "Wiele konfiguracji głowic drukujących",
  productA1216Feature3: "System pozycjonowania wizyjnego",
  productA2513Subtitle: "Flagowa wielkoformatowa drukarka UV płaska",
  productA2513Feature1: "Format druku 2500×1300cm",
  productA2513Feature2: "Wiele konfiguracji głowic drukujących",
  productA2513Feature3: "System pozycjonowania wizyjnego",
  productCylinderElfSubtitle: "Wysokoprędkościowa drukarka cylindryczna 360°",
  productCylinderElfFeature1: "Druk 360°",
  productCylinderElfFeature2: "Personalizacja kubków i butelek",
  productCylinderElfFeature3: "Szybka wymiana oprzyrządowania",
  productCupPlusSubtitle: "Rozwiązanie do druku kubków i butelek w wielu rozmiarach",
  productCupPlusFeature1: "Oprzyrządowanie wielu rozmiarów",
  productCupPlusFeature2: "Wysoka wydajność produkcji",
  productCupPlusFeature3: "Stabilny wynik",
  productCrystal60Subtitle: "System all-in-one do druku i foliowania etykiet kryształowych",
  productCrystal60Feature1: "Szerokość 60cm",
  productCrystal60Feature2: "Integracja druku i foliowania",
  productCrystal60Feature3: "Wydajny system odbioru",
  productCrystalC60UltraFeature1: "Szerokość 60 cm",
  productCrystalC60UltraFeature2: "Opcje folii złoto/srebro/etykiety silikonowe 3D",
  productCrystalC60UltraFeature3: "Produkcja masowa",
  productCrystal30Subtitle: "Kompaktowa precyzyjna drukarka etykiet kryształowych",
  productCrystal30Feature1: "Kompaktowy precyzyjny druk",
  productCrystal30Feature2: "Łatwa obsługa",
  productCrystal30Feature3: "Personalizacja indywidualna",
  productDtf60Subtitle: "Drukarka transferowa DTF z białym atramentem",
  productDtf60Feature1: "Transfer DTF z białym atramentem",
  productDtf60Feature2: "Bogate warstwy kolorów",
  productDtf60Feature3: "Akcesoria odzieżowe",
  productDtfF20Subtitle: "Najmniejsza w branży desktopowa drukarka DTF z białym atramentem",
  productDtfF20Feature1: "Format A4",
  productDtfF20Feature2: "Personalizacja małych serii",
  productDtfF20Feature3: "Inteligentny system atramentu",
  productDtfF30Subtitle: "Desktopowa drukarka DTF z białym atramentem",
  productDtfF30Feature1: "Format A3",
  productDtfF30Feature2: "Jedna głowica manualna/automatyczna do wyboru",
  productDtfF30Feature3: "Inteligentny system atramentu",
  productDtfF30ProSubtitle: "Drukarka DTF z białym atramentem",
  productDtfF30ProFeature1: "Format A3",
  productDtfF30ProFeature2: "Konfiguracja dwóch głowic z automatycznym zwijaniem folii",
  productDtfF30ProFeature3: "Inteligentny system atramentu",
  productDtfF33Subtitle: "Drukarka DTF z białym atramentem",
  productDtfF33Feature1: "Format A3",
  productDtfF33Feature2: "Jedna głowica manualna/automatyczna do wyboru",
  productDtfF33Feature3: "Inteligentny system atramentu",
  productDtfF70ProSubtitle: "Szerokoformatowa drukarka DTF 70 cm z białym atramentem",
  productDtfF70ProFeature1: "Format A2",
  productDtfF70ProFeature2: "Opcje 2�? głowic drukujących",
  productDtfF70ProFeature3: "Automatyczny system podawania i wyprowadzania",
  productDtfF70ProFeature4: "Inteligentny tryb wznawiania druku",
  productDtf30Subtitle: "Kompaktowa drukarka DTF z białym atramentem",
  productDtf30Feature1: "Personalizacja małych serii",
  productDtf30Feature2: "Dokładne odwzorowanie kolorów",
  productDtf30Feature3: "Łatwa w użyciu",
  productDtgPrintSubtitle: "Cyfrowa drukarka bezpośrednio na odzież",
  productDtgPrintFeature1: "Bezpośredni druk na wielu materiałach",
  productDtgPrintFeature2: "Wysoka przepustowość",
  productDtgPrintFeature3: "Stabilna i trwała",
  productDtg3250DSubtitle: "Jedyny w branży model 2-w-1 DTF i DTG",
  productDtg3250DFeature1: "Format A3+",
  productDtg3250DFeature2: "Druk dual-process DTF i DTG",
  productDtg3250DFeature3: "Inteligentny system atramentu",
  productDtg3646TSubtitle: "Drukarka DTG z podwójną stacją",
  productDtg3646TFeature1: "Tryb ciągłej produkcji",
  productDtg3646TFeature2: "100% wzrost wydajności",
  productDtg3646TFeature3: "Inteligentny system atramentu",
  productDtgMaxSubtitle: "Przemysłowa cyfrowa drukarka DTG",
  productDtgMaxFeature1: "Wydajność przemysłowa",
  productDtgMaxFeature2: "Stabilna i trwała",
  productDtgMaxFeature3: "Ciągła praca",
  app01Title: "Etui na telefon",
  app02Title: "Piłki golfowe",
  app03Title: "Kamienne tablice",
  app04Title: "Długopisy",
  app05Title: "Etui na okulary",
  app06Title: "Grawerunki na drewnie",
  app07Title: "Puszki napojów",
  app08Title: "Klawiatury",
  app09Title: "Kubki termiczne",
  app10Title: "Bagaż",
  app11Title: "Produkty akrylowe",
  app12Title: "Notatniki",
  app13Title: "Odznaki",
  app14Title: "Skórzane portfele na karty",
  app15Title: "Identyfikatory",
  app16Title: "Sztuka na szkle",
  appDtgCase01: "Koszulki",
  appDtgCase02: "Bluzy z kapturem",
  regionCn: "Chiny",
  regionUs: "Stany Zjednoczone",
  regionGb: "Wielka Brytania",
  regionDe: "Niemcy",
  regionAe: "ZEA",
  regionIn: "Indie",
  regionJp: "Japonia",
  regionVn: "Wietnam",
  regionBr: "Brazylia",
  regionAu: "Australia",

  // synced from en
    uiClose: "Close",
    carouselPrev: "Previous product",
    carouselNext: "Next product",
    heroSlidePrev: "Previous slide",
    heroSlideNext: "Next slide",
    heroSlideDot: "Go to slide {n}",
    customerStoriesTrustedTitle: "Trusted Worldwide",
    customerStoriesBadge: "{count} international customer photos showcased",
    customerStoryCountryUsaNewYork: "New York, USA",
    customerStoryCountryGermany: "Germany",
    customerStoryCountryThailand: "Thailand",
    customerStoryCountrySpain: "Spain",
    customerStoryCountryBrazil: "Brazil",
    customerStoryCountryAustralia: "Australia",
    customerStoryCountrySaudiArabia: "Saudi Arabia",
    customerStoryCountrySingapore: "Singapore",
    customerStoryCountryKorea: "South Korea",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Kazakhstan",
    customerStoryCountryMexico: "Mexico",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Philippines",
    customerStoryCountryIndonesia: "Indonesia",
    customerStoryCountryNetherlands: "Netherlands",
    customerStoryCountrySweden: "Sweden",
    customerStoryCountrySouthAfrica: "South Africa",
    customerStoryCountryMalaysia: "Malaysia",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "United States",
    customerStoryCaption01: "USA�?090 UV Printer",
    customerStoryCaption02: "Germany｜F33 DTF Printer",
    customerStoryCaption03: "Thailand�?250 UV Printer",
    customerStoryCaption04: "Spain�?250 UV Printer",
    customerStoryCaption05: "Brazil�?030 UV Printer",
    customerStoryCaption06: "Australia｜F33 DTF Printer",
    customerStoryCaption07: "Saudi Arabia�?030 UV Printer",
    customerStoryCaption08: "Singapore｜F33 DTF Printer",
    customerStoryCaption09: "South Korea｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakhstan�?030 UV Printer",
    customerStoryCaption12: "Mexico�?060 UV Printer",
    customerStoryCaption13: "Argentina�?060 UV Printer",
    customerStoryCaption14: "Philippines�?090 UV Printer",
    customerStoryCaption15: "Indonesia�?030 UV Printer",
    customerStoryCaption16: "Netherlands�?030 UV Printer",
    customerStoryCaption17: "Sweden�?060 UV Printer",
    customerStoryCaption18: "Germany�?030 UV Printer",
    customerStoryCaption19: "South Africa�?030 UV Printer",
    customerStoryCaption20: "Malaysia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "USA｜F70Pro DTF Printer",
    customerStoryCaption23: "USA�?513 UV Printer",
    customerStoryCaption24: "USA�?090 UV Printer",
    customerStoryCaption25: "USA�?030 UV Printer",
    customerStoryCaption26: "USA�?250 UV Printer",
    customerStoryCaption27: "South Korea�?060 UV Printer",
    customerStoryCaption28: "Netherlands�?060 UV Printer",
    catUvNav: "UV Flatbed",
    catCylinderNav: "Cylindrical",
    catCrystalNav: "Crystal Label",
    catDtfNav: "DTF",
    catDtgNav: "DTG",
    productA3220Subtitle: "Ultra Wide-Format Industrial UV Flatbed Solution",
    productA3220Feature1: "320×200cm Print Format",
    productA3220Feature2: "Visual Positioning System",
    productA3220Feature3: "Continuous Batch Production",
    productCrystal60UltraSubtitle: "Flagship Crystal Label Printing Solution",
    cityShanghai: "Shanghai",
    cityShenzhen: "Shenzhen",
    cityDetroit: "Detroit",
    cityManchester: "Manchester",
    cityStuttgart: "Stuttgart",
    cityDubai: "Dubai",
    cityPune: "Pune",
    cityOsaka: "Osaka",
    cityHoChiMinh: "Ho Chi Minh City",
    citySaoPaulo: "São Paulo",
    cityMelbourne: "Melbourne",
};
